import dashboard from '../../images/icons/dashboard.png';
import report from '../../images/icons/reports.png';
import TeamLeaderPanel from '../components/TeamLeaderPanel';

const adminNavigationConfig = [
	{
		name: 'Dashboard',
		link: '/dashboard',
		path: dashboard,
		access: 'DASHBOARD',
		description: 'Main dashboard with an overview of key CRM activity',
	},
	{
		name: 'Contacts',
		link: '/dashboard/contacts',
		icon: 'address-book',
		access: 'CONTACT',
		description: 'Search and manage contacts with their data and history',
	},
	{
		name: 'Orders',
		link: '/dashboard/orders',
		icon: 'address-card',
		access: 'ORDER',
		description: 'Search and manage client orders and their statuses',
	},
	{
		name: 'Tickets',
		link: '/dashboard/tickets',
		icon: 'clipboard-list',
		access: 'TICKETS',
		description: 'Browse and handle support tickets from clients',
	},

	{
		name: 'Reports',
		icon: 'chart-simple',
		access: 'REPORTS',
		description: 'Sales, call center and operational reports for admins',
		list: [
			{
				name: 'Sent Orders',
				link: '/report/sent-orders',
				icon: 'paper-plane',
				access: 'REPORTS_SENT_ORDERS',
				description: 'Orders sent to clients with delivery status and filters',
			},
			{
				name: 'UTM',
				link: '/report/utm',
				icon: 'bullhorn',
				access: 'REPORTS_UTM',
				description: 'Order and lead results grouped by UTM campaign parameters',
			},
			{
				name: 'Not pick up calls',
				link: '/report/not-pick-up-calls',
				icon: 'phone',
				access: 'REPORTS_NOT_PICK_UP',
				description: 'Calls that clients did not pick up, for follow-up',
			},
			{
				name: 'Daily',
				link: '/report/daily',
				icon: 'users',
				access: 'REPORTS_DAILY',
				description: 'Daily results of consultants and teams',
			},
			{
				name: 'Daily Market',
				link: '/report/daily-market',
				icon: 'magnifying-glass-chart',
				access: 'REPORTS_DAILY_MARKET',
				description: 'Daily results broken down by market',
			},
			{
				name: 'Effectivity',
				link: '/report/effective',
				icon: 'chart-simple',
				access: 'REPORTS_EFFECTIVE',
				description: 'Consultant effectiveness and conversion statistics',
			},
			{
				name: 'Payment',
				link: '/report/payment',
				icon: 'money',
				access: 'REPORTS_EFFECTIVE_SALARY',
				description: 'Consultant payment and salary calculation based on effectiveness',
			},
			// {
			// 	name: 'Grade',
			// 	link: '/report/grade',
			// 	icon: 'chart-simple',
			// 	access: 'REPORTS_GRADE',
			// },

			{
				name: 'Contacts road',
				link: '/report/contacts-road',
				icon: 'road',
				access: 'REPORTS_CONTACTS_ROAD',
				description: 'Path of contacts through the sales process',
			},
			{
				name: 'Call history',
				link: '/report/consultant',
				icon: 'user',
				access: 'REPORTS_CALLING_HISTORY',
				description: 'Calling history of individual consultants',
			},
			{
				name: 'Cost per lead (Netto)',
				link: '/report/cost-per-lead',
				icon: 'money',
				access: 'REPORTS_CPL',
				description: 'Net cost per lead for ad campaigns',
			},

			{
				name: 'Lang Pair Claim',
				link: '/report/lang-pair-claim',
				icon: 'road',
				access: 'REPORTS_LANG_PAIR',
				description: 'Claims grouped by language pair',
			},
			{
				name: 'Lost packages',
				link: '/report/lost-packages',
				icon: 'road',
				access: 'REPORTS_LOST_PACAKAGE',
				description: 'Packages lost in delivery',
			},
			{
				name: 'Suspicions',
				link: '/report/suspicion',
				icon: 'circle-exclamation',
				access: 'REPORTS_SUSPICIONS',
				description: 'Orders and contacts flagged as suspicious',
			},
			{
				name: 'Product CPL(Netto)',
				link: '/report/product-cpl',
				icon: 'money',
				access: 'REPORTS_PRODUCT_CPL',
				description: 'Net cost per lead broken down by product',
			},
			{
				name: 'Payment Product CPL(Netto)',
				link: '/report/payment-product-cpl',
				icon: 'money',
				access: 'REPORTS_PRODUCT_CPL',
				description: 'Net cost per lead by product based on payments',
			},
			{
				name: 'Resign',
				link: '/report/resign',
				icon: 'ban',
				access: 'REPORTS_RESIGN',
				description: 'Orders resigned by clients and the reasons',
			},
			{
				name: 'Resign new',
				link: '/report/resign-new',
				icon: 'ban',
				access: 'REPORTS_RESIGN',
				description: 'Updated report of orders resigned by clients',
			},
			{
				name: 'Order lang stats',
				link: '/report/order-langs-stats',
				icon: 'language',
				access: 'REPORTS_ORDER_LANGS_STATS',
				description: 'Order statistics by language',
			},
			{
				name: 'Mails',
				link: '/report/mails',
				icon: 'envelope-circle-check',
				access: 'REPORTS_MAIL_CATEGORY',
				description: 'Statistics of sent mails by category',
			},
			{
				name: 'Profitability',
				link: '/report/profitability',
				icon: 'comments-dollar',
				access: 'REPORTS_PROFITABILITY',
				description: 'Profitability of sales by market and product',
			},
			{
				name: 'Quiz',
				link: '/report/quiz',
				icon: 'clipboard-question',
				access: 'REPORTS_QUIZ',
				description: 'Results of quizzes completed by employees',
			},
			{
				name: 'Quiz Test',
				link: '/report/quiz-test',
				icon: 'clipboard-question',
				access: 'REPORTS_QUIZ_TEST',
				description: 'Results of test quizzes completed by candidates',
			},
			{
				name: 'CC Weekly',
				link: '/report/cc-weekly',
				icon: 'calendar-week',
				access: 'REPORTS_CC_WEEKLY',
				description: 'Weekly summary of call center performance',
			},
			{
				name: 'Queue Leads Guessing',
				link: '/report/queue-leads-guessing',
				icon: 'question-circle',
				access: 'REPORTS_QUEUE_LEADS_GUESSING',
				description: 'Lead queue assignment and guessing statistics',
			},
			{
				name: 'Page Events',
				link: '/report/page-events',
				icon: 'elementor',
				access: 'REPORTS_PAGE_EVENTS',
				description: 'Visitor events tracked on landing pages',
			},
			{
				name: 'Employee KPI',
				link: '/report/employee-kpi',
				icon: 'chart-line',
				access: 'REPORTS_EMPLOYEE_KPI',
				description: 'KPI results of employees',
			},
			{
				name: 'Not Delivered Packages',
				link: '/report/not-delivered-packages',
				icon: 'boxes-packing',
				access: 'REPORTS_NOT_DELIVERED_PACKAGES',
				description: 'Packages that were sent but not delivered',
			},
			{
				name: 'SERP Monitoring',
				link: '/report/serp-monitoring',
				icon: 'search',
				access: 'REPORTS_SERP_MONITORING',
				description: 'Search engine result positions tracked for monitored phrases',
			},
		],
	},

	{
		name: 'Mail',
		icon: 'envelope',
		access: 'MAIL',
		description: 'Search and configure mails sent and received by the CRM',
		list: [
			{
				name: 'Search',
				link: '/mail/search',
				icon: 'envelope',
				access: 'MAIL_SEARCH',
				description: 'Search mails sent to and received from clients',
			},
			{
				name: 'Template',
				link: '/mail/template',
				icon: 'file',
				access: 'MAIL_TEMPLATE_VIEW',
				description: 'Manage mail templates',
			},
			{
				name: 'Test',
				link: '/mail/test',
				icon: 'file',
				access: 'MAIL_TEST_VIEW',
				description: 'Send and preview test mails',
			},
			{
				name: 'Category',
				link: '/mail/category',
				icon: 'list',
				access: 'MAIL_CATEGORY_VIEW',
				description: 'Manage mail categories',
			},
			{
				name: 'Recruitment category',
				link: '/mail/recruitment-mail',
				icon: 'list',
				access: 'MAIL_RECRUITMENT_CATEGORY',
				description: 'Manage mail categories used in recruitment',
			},
			{
				name: 'Attachments',
				link: '/mail/attachments',
				icon: 'paperclip',
				access: 'MAIL_ATTACHMENTS',
				description: 'Manage files attached to mails',
			},
		],
	},
	{
		name: 'Accounting',
		path: report,
		access: 'ACCOUNTING',
		description: 'Claims, invoices, refunds and payment reports',
		list: [
			{
				name: 'Claim Search',
				link: '/hr/claim/search',
				icon: 'file-circle-exclamation',
				access: 'ACCOUNTING_CLAIMS_SEARCH',
				description: 'Search claims with filters',
			},
			{
				name: 'Claims',
				link: '/hr/claim/not_ended_claims',
				icon: 'file-circle-exclamation',
				access: 'ACCOUNTING_CLAIMS',
				description: 'Claims that are still open',
			},
			{
				name: 'Claims Report',
				link: '/hr/claims-report',
				icon: 'file-circle-exclamation',
				access: 'ACCOUNTING_CLAIMS_REPORT',
				description: 'Summary report of claims',
			},
			{
				name: 'Invoices',
				link: '/hr/invoices',
				icon: 'file-invoice',
				access: 'ACCOUNTING_INVOICES',
				description: 'Browse and manage issued invoices',
			},
			{
				name: 'Invoices Report',
				link: '/hr/invoices-report',
				icon: 'file-invoice-dollar',
				access: 'ACCOUNTING_INVOICES_REPORT',
				description: 'Summary report of invoices',
			},
			{
				name: 'Valid invoices',
				link: '/valid-invoices',
				icon: 'file-invoice',
				access: 'VALID_INVOICES_GET',
				description: 'Browse and manage valid invoices',
			},
			{
				name: 'Valid Invoices Report',
				link: '/valid-invoices-report',
				icon: 'file-invoice-dollar',
				access: 'ACCOUNTING_INVOICES',
				description: 'Summary report of valid invoices',
			},
			{
				name: 'Valid Claims',
				link: '/valid-claims',
				icon: 'receipt',
				access: 'VALID_CLAIMS_GET',
				description: 'Browse and manage valid claims',
			},
			{
				name: 'Valid claims feedback',
				link: '/report/valid-claims-feedback-report',
				icon: 'comment',
				access: 'REPORTS_VALID_CLAIMS_FEEDBACK',
				description: 'Feedback collected on valid claims',
			},
			{
				name: 'Valid Claims Report',
				link: '/report/valid-claims-report',
				icon: 'file-invoice',
				access: 'REPORTS_VALID_CLAIMS',
				description: 'Summary report of valid claims',
			},
			{
				name: 'Payment Report',
				link: '/report/operator-payment-report',
				icon: 'file-invoice',
				access: 'OPERATOR_PAYMENT_REPORT',
				description: 'Payments made to operators',
			},
			{
				name: 'Refunds',
				link: '/refunds',
				icon: 'book',
				access: 'FIND_REFUNDS',
				description: 'Search and manage refunds',
			},
		],
	},
	{
		name: 'Voip',
		icon: 'phone',
		access: 'VOIP',
		description: 'Calls, SMS and call quality tools',
		list: [
			{
				name: 'SMS Search',
				link: '/voip/sms/search',
				icon: 'sms',
				access: 'VOIP_SMS_SEARCH',
				description: 'Search sent and received SMS messages',
			},
			{
				name: 'SMS Create',
				link: '/voip/sms/create',
				icon: 'sms',
				access: 'VOIP_SMS_CREATE',
				description: 'Create and send an SMS message',
			},
			{
				name: 'Grading',
				link: '/voip/listening-marks',
				icon: 'ear-listen',
				access: 'VOIP_MARKS',
				description: 'Grade recorded calls',
			},
			{
				name: 'Scoring listening',
				link: '/voip/listening-scoring',
				icon: 'headphones',
				access: 'VOIP_SCORING',
				description: 'Score recorded calls by listening',
			},
			{
				name: 'Calling Search',
				link: '/voip/calling/search',
				icon: 'phone',
				access: 'VOIP_CALLING_SEARCH',
				description: 'Search call records with filters',
			},
			{
				name: 'Realtime',
				link: '/voip/realtime-dashboard',
				icon: 'home',
				access: 'VOIP_REALTIME',
				description: 'Live view of current calls and consultant status',
			},
			{
				name: 'Working',
				link: '/voip/working-time',
				icon: 'clock',
				access: 'VOIP_WORKING_TIME',
				description: 'Working time of consultants based on call activity',
			},
			{
				name: 'Statistics',
				link: '/voip/statistics',
				icon: 'chart-bar',
				access: 'VOIP_STATISTICS',
				description: 'Call statistics for consultants and queues',
			},
			{
				name: 'Listening',
				link: '/voip/listening',
				icon: 'ear-listen',
				access: 'VOIP_LISTENING',
				description: 'Listen to recorded calls',
			},
			{
				name: 'AI Call Analysis',
				link: '/voip/call-analysis',
				icon: 'ear-listen',
				access: 'AI_CALL_ANALYSIS',
				description: 'AI analysis of recorded calls',
			},
			{
				name: 'AI Analysis Report',
				link: '/voip/call-analysis-report',
				icon: 'chart-bar',
				access: 'AI_CALL_ANALYSIS',
				description: 'Summary report of AI call analysis results',
			},
			{
				name: 'AI Analysis Config',
				link: '/voip/call-analysis-config',
				icon: 'gear',
				access: 'AI_CALL_ANALYSIS',
				description: 'Configure AI call analysis settings',
			},
			{
				name: 'Scoring',
				link: '/voip/listening-scores',
				icon: 'star',
				access: 'VOIP_SCORING',
				description: 'Scores given to listened calls',
			},
			{
				name: 'Archive',
				link: '/voip/archive',
				icon: 'box-archive',
				access: 'VOIP_ARCHIVE',
				description: 'Archive of call recordings',
			},
			{
				name: 'Calling Information',
				link: '/voip/calling-information',
				icon: 'circle-info',
				access: 'CALLING_INFORMATION_GET',
				description: 'Details of calling configuration and information',
			},
		],
	},
	{
		name: 'CC',
		icon: 'headphones',
		access: 'CC',
		description: 'Call center hours, payments, gamification and recruitment',
		list: [
			{
				name: 'Hours',
				link: '/cc/hours',
				icon: 'clock-o',
				access: 'CC_HOURS',
				description: 'Working hours of call center employees',
			},
			{
				name: 'Hours report',
				link: '/cc/hours_report',
				icon: 'hourglass-end',
				access: 'CC_HOURS_REPORT',
				description: 'Report of worked hours of call center employees',
			},
			{
				name: 'Payment',
				link: '/cc/payment',
				icon: 'money',
				access: 'CC_PAYMENT',
				description: 'Payments for call center employees',
			},
			{
				name: 'Payment KDR',
				link: '/cc/payment_kdr',
				icon: 'money',
				access: 'CC_PAYMENT_KDR',
				description: 'Call center payments calculated with KDR rules',
			},
			{
				name: 'Payment short',
				link: '/cc/payment-short',
				icon: 'money',
				access: 'CC_PAYMENT',
				description: 'Short summary of call center payments',
			},
			{
				name: 'Gamification',
				link: '/cc/gamification',
				icon: 'play',
				access: 'CC_GAMIFICATION',
				description: 'Gamification results and rankings of consultants',
			},
			{
				name: 'Gamification new',
				link: '/cc/gamification/new',
				icon: 'star',
				access: 'CC_GAMIFICATION',
				description: 'Updated gamification results of consultants',
			},
			{
				name: 'Payout slip',
				link: '/cc/payout-slip',
				icon: 'cash-register',
				access: 'CC_PAYMENT',
				description: 'Payout slips for call center employees',
			},
			{
				name: 'Speech to text',
				link: '/cc/speech-to-text',
				icon: 'comment',
				access: 'CC_SPEECH_TO_TEXT',
				description: 'Transcriptions of calls converted from speech to text',
			},
			{
				name: 'Recruitment',
				link: '/cc/recruitment',
				icon: 'users',
				access: 'CC_RECRUITMENT',
				description: 'Call center candidates and recruitment process',
			},
			{
				name: 'Follow Up Shipments',
				link: '/cc/follow-up-shipments',
				icon: 'truck-ramp-box',
				access: 'CC_FOLLOW_UP_SHIPMENTS',
				description: 'Follow-up of shipments to clients',
			},
			{
				name: 'Follow Up Payments',
				link: '/cc/follow-up-payments',
				icon: 'credit-card',
				access: 'CC_FOLLOW_UP_PAYMENTS',
				description: 'Follow-up of pending client payments',
			},
			{
				name: 'Files',
				link: '/cc/files',
				icon: 'file',
				access: 'CRM_SETTINGS_FILES',
				description: 'Files shared with call center employees',
			},
		],
	},
	{
		name: 'CRM settings',
		icon: 'gear',
		access: 'CRM_SETTINGS',
		description: 'System configuration of markets, users, products and more',
		list: [
			{
				name: 'Markets',
				link: '/settings/market/list',
				icon: 'location-dot',
				access: 'CRM_SETTINGS_MARKETS',
				description: 'Manage markets',
			},
			{
				name: 'Users',
				link: '/settings/user/list',
				icon: 'location-dot',
				access: 'CRM_SETTINGS_USERS',
				description: 'Manage CRM users and their access',
			},
			{
				name: 'Queues',
				link: '/settings/queue/list',
				icon: 'chess-queen',
				access: 'CRM_SETTINGS_QUEUES',
				description: 'Manage call and lead queues',
			},
			{
				name: 'Products',
				link: '/settings/product/list',
				icon: 'product-hunt',
				access: 'CRM_SETTINGS_PRODUCTS',
				description: 'Manage products',
			},
			{
				name: 'Super products',
				link: '/settings/super-product/list',
				icon: 'list',
				access: 'CRM_SETTINGS_SUPER_PRODUCTS',
				description: 'Manage super products grouping products',
			},
			{
				name: 'Instant Forms',
				link: '/settings/instant-forms/list',
				icon: 'id-card',
				access: 'CRM_SETTINGS_INSTANT_FORMS',
				description: 'Manage instant lead forms',
			},
			{
				name: 'Dictionary',
				link: '/settings/dictionary',
				icon: 'spell-check',
				access: 'CRM_SETTINGS_DICTIONARY',
				description: 'Manage dictionary entries and translations',
			},
			{
				name: 'Blackboard',
				link: '/settings/blackboard/list',
				icon: 'chalkboard',
				access: 'CRM_SETTINGS_BLACKBOARD',
				description: 'Manage announcements shown on the blackboard',
			},
			{
				name: 'FAQ',
				link: '/settings/faq/list',
				icon: 'question',
				access: 'CRM_SETTINGS_FAQ',
				description: 'Manage frequently asked questions',
			},
			{
				name: 'Drafts',
				link: '/settings/drafts/list',
				icon: 'file',
				access: 'CRM_SETTINGS_DRAFTS',
				description: 'Manage message drafts',
			},
			{
				name: 'LI Gen',
				link: '/settings/listening-generator',
				icon: 'ear-listen',
				access: 'CRM_SETTINGS_LISTENING_GENERATOR',
				description: 'Generate listening tasks',
			},
			{
				name: 'Meta',
				link: '/settings/meta',
				icon: 'meta',
				access: 'CRM_SETTINGS_META',
				description: 'Manage Meta ads integration settings',
			},
			{
				name: 'Language',
				link: '/settings/languages',
				icon: 'globe',
				access: 'CRM_SETTINGS_LANGUAGE',
				description: 'Manage available languages',
			},
			{
				name: 'Tests',
				link: '/settings/test/list',
				icon: 'question-circle',
				access: 'CRM_SETTINGS_TEST_GET_ALL',
				description: 'Manage tests for employees',
			},
			{
				name: 'Gamification',
				link: '/settings/gamification',
				icon: 'star',
				access: 'CC_GAMIFICATION',
				description: 'Configure gamification rules',
			},
			{
				name: 'Invoice Templates',
				link: '/settings/invoice-templates',
				icon: 'pen-ruler',
				access: 'CRM_SETTINGS_INVOICE_TEMPLATE',
				description: 'Manage invoice templates',
			},
			{
				name: 'Keys',
				link: '/settings/keys',
				icon: 'key',
				access: 'CRM_SETTINGS_KEYS',
				description: 'Manage API keys and integration keys',
			},
			{
				name: 'Companies',
				link: '/settings/companies',
				icon: 'building',
				access: 'CRM_SETTINGS_COMPANY',
				description: 'Manage companies used on invoices',
			},
			{
				name: 'Invoices config',
				link: '/settings/invoice-config',
				icon: 'font',
				access: 'CRM_SETTINGS_INVOICE_CONFIG',
				description: 'Configure invoice generation settings',
			},
			{
				name: 'Server Refresh',
				link: '/settings/server-refresh',
				icon: 'server',
				access: 'CRM_SETTINGS_SERVER_REFRESH',
				description: 'Refresh server data and caches',
			},
			{
				name: 'Department',
				link: '/settings/department',
				icon: 'building',
				access: 'CRM_SETTINGS_DEPARTMENT',
				description: 'Manage departments',
			},
			{
				name: 'Bonus',
				link: '/settings/bonus',
				icon: 'gift',
				access: 'CRM_SETTINGS_BONUS',
				description: 'Configure employee bonuses',
			},
			{
				name: 'SERP monitoring',
				link: '/settings/serp-monitoring',
				icon: 'search',
				access: 'CRM_SETTINGS_SERP_MONITORING',
				description: 'Configure phrases monitored in search results',
			},
			{
				name: 'Recruitment page',
				link: '/settings/recruitment-page',
				icon: 'users',
				access: 'CRM_SETTINGS_RECRUITMENT',
				description: 'Configure the recruitment page content',
			},
			{
				name: 'Call center position',
				link: '/settings/call-center-position',
				icon: 'tag',
				access: 'CRM_SETTINGS_POSITION',
				description: 'Manage call center positions',
			},
			{
				name: 'Dynamic mail content',
				link: '/settings/dynamic-mail-content',
				icon: 'envelope-open',
				access: 'CRM_SETTINGS_DYNAMIC_MAIL_CONTENT',
				description: 'Manage dynamic content inserted into mails',
			},
			{
				name: 'Dynamic mail attachment',
				link: '/settings/dynamic-mail-attachment',
				icon: 'envelope-open',
				access: 'CRM_SETTINGS_DYNAMIC_MAIL_ATTACHMENT',
				description: 'Manage dynamic attachments added to mails',
			},
			{
				name: 'Promotion',
				link: '/settings/promotion',
				icon: 'funnel-dollar',
				access: 'CRM_SETTINGS_PROMOTION',
				description: 'Manage promotions',
			},
			{
				name: 'Mailing Reports',
				link: '/settings/mailing-reports',
				icon: 'envelope',
				access: 'CRM_SETTINGS_MAILING_REPORTS',
				description: 'Configure automatic mailing of reports',
			},
			{
				name: 'Spends',
				link: '/settings/spends',
				icon: 'money-bill',
				access: 'CRM_SETTINGS_SPEND',
				description: 'Manage advertising spends',
			},
		],
	},
];

const consultantNavigationConfig = [
	{
		name: 'Dashboard',
		link: '/consultant/dashboard',
		icon: 'bi bi-grid-3x3-gap',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'My_statistics',
		link: '/consultant/statistics',
		icon: 'bar-chart',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'My_orders',
		link: '/consultant/orders',
		icon: 'address-book',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'My_salary',
		link: '/consultant/salary',
		icon: 'dollar',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Hours',
		link: '/consultant/hours',
		icon: 'clock-o',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Refunds',
		link: '/consultant/refunds',
		icon: 'book',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Tickets',
		link: '/consultant/tickets',
		icon: 'tasks',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Listening',
		link: '/consultant/listening',
		icon: 'ear-listen',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'FAQ',
		link: '/consultant/faq',
		icon: 'question',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Drafts',
		link: '/consultant/drafts',
		icon: 'file',
		access: 'CONSULTANT_COMMON',
	},
	// {
	//   name: "Tests",
	//   link: "/consultant/tests",
	//   icon: "check",
	//   access: "CONSULTANT_COMMON",
	// },
	// {
	//   name: "Gamification",
	//   link: "/consultant/gamification",
	//   icon: "fas gamepad",
	//   access: "CONSULTANT_COMMON",
	// },
	{
		name: 'Follow Up Shipments',
		link: '/consultant/follow-up-shipments',
		icon: 'truck-ramp-box',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Follow Up Payments',
		link: '/consultant/follow-up-payments',
		icon: 'credit-card',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Email',
		link: '/consultant/email',
		icon: 'envelope',
		access: 'CONSULTANT_COMMON',
	},
	{
		name: 'Your Team',
		icon: 'users',
		access: 'CONSULTANT_MANAGER',
		element: (setShow) => <TeamLeaderPanel setShow={setShow} />,
	},
];

const NAVIGATION_SECTION_PATH = '/navigation';
const ADMIN_HOME_PATH = '/dashboard';

export {
	ADMIN_HOME_PATH,
	adminNavigationConfig,
	consultantNavigationConfig,
	NAVIGATION_SECTION_PATH,
};
